import { render } from "./ReadingStreakWidgetSkeleton16464.vue?vue&type=template&id=023e7754&scoped=true"
const script = {}

import "./ReadingStreakWidgetSkeleton16464.vue?vue&type=style&index=0&id=023e7754&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023e7754"]])

export default __exports__